import * as React from 'react';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import WifiOffRoundedIcon from '@mui/icons-material/WifiOffRounded';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide() {
  const handleClose = () => {
    // setOpen(false);
    window.location.reload();
  };

  const [isOnline, setIsOnline] = React.useState(navigator.onLine);

  React.useEffect(() => {
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };
    window.addEventListener('online', handleStatusChange);
    window.addEventListener('offline', handleStatusChange);
    return () => {
      window.removeEventListener('online', handleStatusChange);
      window.removeEventListener('offline', handleStatusChange);
    };
  }, [isOnline]);

  return (
    <React.Fragment>
      <Dialog
        dir="rtl"
        keepMounted
        open={!isOnline}
        onClose={handleClose}
        TransitionComponent={Transition}
        aria-describedby="offline-alert"
        PaperProps={{
          sx: {
            bgcolor: 'warning.main',
          },
        }}
      >
        <DialogContent>
          <Stack py={2} rowGap={3} alignItems="center" justifyContent="center">
            <Avatar
              sx={{
                width: 120,
                height: 120,
                fontSize: 60,
                color: 'warning.dark',
                bgcolor: 'warning.lighter',
              }}
            >
              <WifiOffRoundedIcon fontSize="inherit" color="inherit" />
            </Avatar>
            <Typography align="center" variant="h2" color="#fff">
              خطای شبکه
            </Typography>
            <Typography align="center" variant="subtitle2" color="#fff">
              لطفا دسترسی اینترنت خود را بررسی کنید!
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button fullWidth color="inherit" variant="outlined" onClick={handleClose}>
            تلاش مجدد
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
